// extracted by mini-css-extract-plugin
module.exports = {"table":"AppUsersDetails_table__3P_MW"};